import React from 'react'
import PropTypes from 'prop-types'

import { H1, Button } from '../Common'

import style from './SignupFacebook.scss'

import disappointed from '../../images/emojis/disappointed.svg'

function SignupFacebookError({ onInitialStep }) {
  return (
    <div className={style.wrapper}>
      <img src={disappointed} alt="Ahhh!" />
      <H1>ops!</H1>
      <p>
        Não foi possível criar a sua conta através do Facebook. Tente recomeçar o processo ou se cadastre por e-mail.
      </p>
      <Button onClick={onInitialStep} xl>
        recomeçar através do e-mail
      </Button>
    </div>
  )
}

SignupFacebookError.propTypes = {
  onInitialStep: PropTypes.func,
}

export default SignupFacebookError



// WEBPACK FOOTER //
// ./src/components/Pages/SignupFacebookError.js